import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/settings/admin/company_store_settings/Page";
import { Page as Error403Component } from "~/containers/specifics/403/Page";
import useItandiAccount from "~/hooks/useItandiAccount";

export const PATH = "/settings/admin/company_store_settings";

const Home: NextPage = () => {
	const { data: session } = useItandiAccount().currentAccount();
	if (session === null || !session.isAdmin || session.store === null) {
		return <Error403Component />;
	}

	return (
		<>
			<NskHead title="店舗設定" />
			<Component currentStore={session.store} />
		</>
	);
};
export default Home;
